<style scoped>
@import url(../../style/innovativeManufacturing/innovativeManufacturing.css);
@import url(../../style/innovativeManufacturing/certification-stats.css);
@import url(../../style/innovativeManufacturing/company-advantages.css);
@import url(../../style/innovativeManufacturing/product-strategy.css);
@import url(../../style/innovativeManufacturing/brand-honors.css);
@import url(../../style/innovativeManufacturing/scroll-reveal.css);
</style>

<template>
  <div class="innovative-manufacturing-page">
    <!-- 头部导航组件 -->
    <AppHeader />

    <!-- 页面主要内容区域 -->
    <main class="page-content">
      <!-- 主要内容区 大图背景模块-->
      <main class="main-content scroll-reveal">
        <img class="bg-img" src="https://hfqsyl.oss-cn-hangzhou.aliyuncs.com/img/web20260731161014095.jpg" alt="创新智造背景" />
        <div class="text-content">
          <h1>创新智造</h1>
          <p>以科技之力守护皮肤健康</p>
        </div>
      </main>

      <!-- 认证和统计部分 -->
      <section class="certification-section scroll-reveal delay-1">
        <div class="certification-container">
          <h2 class="certification-title">我们拥有这些认证</h2>

          <!-- 认证标志 -->
          <div class="certification-logos">
            <div class="certification-logo">
              <img src="../assets/uploads/innovativeManufacturing/NMPA.svg" alt="NMPA认证">
            </div>
            <div class="certification-logo">
              <img src="../assets/uploads/innovativeManufacturing/FDA.svg" alt="FDA认证">
            </div>
            <div class="certification-logo">
              <img src="../assets/uploads/innovativeManufacturing/CE.svg" alt="CE认证">
            </div>
            <div class="certification-logo">
              <img src="../assets/uploads/innovativeManufacturing/ISO.svg" alt="ISO认证">
            </div>
            <div class="certification-logo">
              <img src="../assets/uploads/innovativeManufacturing/Intertek.svg" alt="Intertek认证">
            </div>
          </div>

          <!-- 统计数据 -->
          <div class="stats-container">
            <div class="stats-grid">
              <div class="stat-item">
                <div class="stat-number">5+</div>
                <div class="stat-label">国家级科技计划项目</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">14+</div>
                <div class="stat-label">省市级科技计划项目</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">200+</div>
                <div class="stat-label">医疗器械注册产品</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">210+</div>
                <div class="stat-label">知识产权</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 企业优势部分 -->
      <section class="company-advantages-section">
        <div class="company-advantages-container">
          <div class="advantages-grid">
            <div class="advantage-item scroll-reveal" v-for="(advantage, index) in advantagesFirstRow"
              :key="'first-' + index" :class="'delay-' + (index + 1)">
              <img :src="specPics[index % specPics.length]" alt="产品示例" class="advantage-image">
              <div class="advantage-content">
                <div class="advantage-title">{{ advantage.title }}</div>
                <div class="advantage-description">{{ advantage.description }}</div>
              </div>
            </div>
          </div>

          <div class="advantages-grid">
            <div class="advantage-item scroll-reveal" v-for="(advantage, index) in advantagesSecondRow"
              :key="'second-' + index" :class="'delay-' + (advantagesFirstRow.length + index + 1)">
              <img :src="specPics[(advantagesFirstRow.length + index) % specPics.length]" alt="产品示例"
                class="advantage-image">
              <div class="advantage-content">
                <div class="advantage-title">{{ advantage.title }}</div>
                <div class="advantage-description">{{ advantage.description }}</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 产品战略部分 -->
      <section class="product-strategy-section scroll-reveal delay-3">
        <div class="product-strategy-container">
          <h2 class="product-strategy-title">产品战略</h2>
          <p class="product-strategy-content"> 千手医疗是致力于高科技医疗电子产品研发、生产、销售及服务的股份制企业。产品类别覆盖皮肤美容、妇科、康复、耳鼻喉、眼科、急救等领域，在
            美国、日本、俄罗斯、新加坡等国家设有分支机构，中国国内各省份均有办事处。 </p>

          <div class="product-strategy-grid">
            <div class="product-strategy-item" v-for="(product, index) in productStrategies" :key="index"
              :class="{ 'reverse': product.reverse }">
              <div class="product-strategy-image">
                <img :src="product.imageUrl" :alt="product.title">
              </div>
              <div class="product-strategy-text">
                <h3 class="product-strategy-heading">{{ product.title }}</h3>
                <div class="product-description">{{ product.description }}</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 品牌荣誉部分 -->
      <section class="brand-honors-section scroll-reveal delay-4">
        <div class="brand-honors-container">
          <div class="honors-content">
            <h2 class="honors-title">品牌荣誉</h2>
            <div class="honors-text">
              <h3>27年我们用心诠释健康的意义</h3>
              <p>千手医疗是致力于高科技医疗电子产品研发、生产、销售及服务的股份制企业。产品类别覆盖皮肤美容、妇科、康复、耳鼻喉、眼科、急救等领域，在美国、日本、俄罗斯、新加坡等国家设有分支机构，中国国内各省份均有办事处。
              </p>
              <p>目前，公司产品主要包括皮肤美容类、盆底治疗类、皮肤康复类、妇科类、急救类、激光生发仪六大类别，先进的技术及超前的研发理念为企业的可持续发展奠定坚实的基础，确保公司产品设计和技术研发一直保持在领先水平。
              </p>
            </div>
          </div>
          <div class="honors-logos">
            <div class="honor-logo" v-for="(logo, index) in honorLogos" :key="index">
              <div class="logo-container">
                <img :src="logo.imageUrl" :alt="logo.title" class="default-logo">
                <img src="../assets/images/product-ex.png" :alt="'悬浮图片 ' + logo.title" class="hover-logo">
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

    <!-- 底部组件 -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'

export default {
  name: 'InnovativeManufacturing',
  components: {
    AppHeader,
    AppFooter
  },
  mounted() {
    // 直接跳转到页面顶部（无平滑过渡）
    window.scrollTo(0, 0);

    // 添加滚动显示效果的监听
    this.addScrollRevealListener();
  },

  beforeUnmount() {
    // 移除滚动监听
    window.removeEventListener('scroll', this.handleScroll);
  },

  computed: {
    // 计算所有优势项，用于确保顺序正确
    allAdvantages() {
      return [...this.advantagesFirstRow, ...this.advantagesSecondRow];
    }
  },

  methods: {
    // 添加滚动显示效果的监听
    addScrollRevealListener() {
      // 立即执行一次检查，确保页面加载时可见的元素也能显示
      this.checkScrollReveal();
      // 添加滚动事件监听
      window.addEventListener('scroll', this.handleScroll);
    },

    // 处理滚动事件，使用节流函数优化性能
    handleScroll() {
      // 节流处理
      if (!this.scrollTimeout) {
        this.scrollTimeout = setTimeout(() => {
          this.checkScrollReveal();
          this.scrollTimeout = null;
        }, 100); // 减少节流时间，使显示更及时
      }
    },

    // 检查并显示进入视口的元素
    checkScrollReveal() {
      const revealElements = document.querySelectorAll('.scroll-reveal');
      const windowHeight = window.innerHeight;

      // 按DOM顺序处理元素，确保显示顺序正确
      const elementsArray = Array.from(revealElements);

      elementsArray.forEach(element => {
        const elementTop = element.getBoundingClientRect().top;
        const elementBottom = element.getBoundingClientRect().bottom;

        // 当元素的任何部分进入视口底部100px范围内时开始显示
        if (elementTop < windowHeight - 100 && elementBottom > 0) {
          element.classList.add('active');
        }
      });
    }
  },

  data() {
    return {
      scrollTimeout: null,
      // spec-pics图片数组
      specPics: [
        require('../assets/images/homepage/spec-pics/spec-pic1.png'),
        require('../assets/images/homepage/spec-pics/spec-pic2.png'),
        require('../assets/images/homepage/spec-pics/spec-pic3.png'),
        require('../assets/images/homepage/spec-pics/spec-pic4.jpg'),
        require('../assets/images/homepage/spec-pics/spec-pic5.jpg')
      ],
      advantagesFirstRow: [
        {
          title: '值得信赖',
          description: '全球用户信赖的医疗器械智造品牌'
        },
        {
          title: '200+产品型号',
          description: '生产超过200+产品型号'
        },
        {
          title: '智能制造',
          description: '400套套智能工装、设备'
        },
        {
          title: '研发基地',
          description: '位于总部的生产中心总建筑面积超过10000㎡'
        },
        {
          title: '产品交付',
          description: '智造产品交付全球33600个医疗机构服务全球300万用户'
        }
      ],
      advantagesSecondRow: [
        {
          title: '医疗应用',
          description: '千手医疗应用于全球知名的医疗机构'
        },
        {
          title: '学术共建',
          description: '千手始终尊重学术，支持学术，凝聚学术智慧，打造全球产学研一体化创新平台'
        },
        {
          title: '产品出海',
          description: '产品进入160多个国家医疗中共32个州的知名医院选择千手医疗'
        },
        {
          title: '产品畅销',
          description: '千手医疗的产品畅销欧洲、亚洲东南亚、南美、中东等地区的数十个国家'
        },
        {
          title: '国内外合作',
          description: '交付给全球33600个医疗机构服务全球300万用户'
        }
      ],
      productStrategies: [
        {
          title: '皮肤美容类',
          description: '高价值智慧医疗产品、窄波紫外线治疗产品、光生物调节产品、PDT光动力治疗产品、LLLT低能量激光产品、反射式共振光学设备',
          imageUrl: require('../assets/images/product-example.jpg'),
          reverse: false
        },
        {
          title: '产康类',
          description: '超高清电子阴道镜、创新光电一体阴道镜盆底康复产品、电刺激技术、磁刺激技术',
          imageUrl: require('../assets/images/inno/inno1.jpg'),
          reverse: true
        },
        {
          title: '居家医疗生态',
          description: '鼻科类、眼科类、慢病调理类、婴幼儿类等等',
          imageUrl: require('../assets/images/inno/inno2.png'),
          reverse: false
        }
      ],
      honorLogos: [
        { title: '荣誉标志1', imageUrl: require('../assets/images/logo-example.png') },
        { title: '荣誉标志2', imageUrl: require('../assets/images/logo-example.png') },
        { title: '荣誉标志3', imageUrl: require('../assets/images/logo-example.png') },
        { title: '荣誉标志4', imageUrl: require('../assets/images/logo-example.png') },
        { title: '荣誉标志5', imageUrl: require('../assets/images/logo-example.png') },
        { title: '荣誉标志6', imageUrl: require('../assets/images/logo-example.png') },
        { title: '荣誉标志7', imageUrl: require('../assets/images/logo-example.png') },
        { title: '荣誉标志8', imageUrl: require('../assets/images/logo-example.png') }
      ]
    }
  }
}
</script>

<style scoped>
.innovative-manufacturing-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.page-content {
  flex: 1;
}

/* 荣誉标志悬浮效果 */
.honor-logo {
  position: relative;
  cursor: pointer;
}

.logo-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.default-logo,
.hover-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: absolute;
  top: 0;
  left: 0;
  display: block;
}

.default-logo {
  z-index: 1;
}

.hover-logo {
  z-index: 2;
  transform: translateY(100%);
  transition: transform 0.3s ease;
}

.honor-logo:hover .hover-logo {
  transform: translateY(0);
  opacity: 0.7;
}
</style>